export default __webpack_public_path__ + "static/media/WestSettlementofDinog.13272f53.jpg";